export default "__VITE_ASSET__2b54bc2d__"